import React, { Component } from 'react';
import PropTypes from "prop-types";
import { formatClassName } from '../Util';

export default class Icon extends Component {
  static propTypes = {
    additionalClasses: PropTypes.string,
    color: PropTypes.oneOf(['white', 'green', 'teal', 'red', 'yellow', 'blue']),
    fontFamily: PropTypes.string,
    iconType: PropTypes.string,
    onClick: PropTypes.func,
    size: PropTypes.oneOf(['small', 'medium', 'large', 'extralarge']),
    spin: PropTypes.bool,
    title: PropTypes.string,
    transform: PropTypes.oneOf(['rotate-90', 'rotate-180', 'rotate-270', 'flip-horizontal', 'flip-vertical'])
  };

  static defaultProps = {
    fontFamily: 'zmdi',
    size: 'small',
    spin: false,
    additionalClasses: 'left'
  };

  get size() {
    switch(this.props.size) {
    case 'small':
      return '';
    case 'medium':
      return 'zmdi-hc-lg';
    case 'large':
      return 'zmdi-hc-2x';
    case 'extralarge':
      return 'zmdi-hc-3x';
    default:
      return;
    }
  }

  get transform() {
    switch (this.props.transform) {
    case 'rotate-90':
    case 'rotate-180':
    case 'rotate-270':
    case 'flip-horizontal':
    case 'flip-vertical':
      return `zmdi-hc-${this.props.transform}`;
    default:
      return;
    }
  }

  buildLabelIcon = () => {
    const { iconType, fontFamily, spin, additionalClasses } = this.props;
    let font_family_prefix = "zmdi zmdi-"
    if(fontFamily) {
      font_family_prefix = `${fontFamily} ${fontFamily}-`;
    }
    if(iconType && fontFamily && iconType.includes(`${fontFamily}-`)) {
      font_family_prefix = `${fontFamily} `;
    }

    return formatClassName([
      additionalClasses,
      `${font_family_prefix}${iconType}`,
      this.props.color,
      this.size,
      this.transform,
      { 'zmdi-hc-spin': spin }
    ]);
  }

  render() {
    let classes = this.buildLabelIcon();
    return (
      classes && <i title={this.props.title} className={classes} aria-hidden="true" onClick={this.props.onClick} />
    )
  }
}
